import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Tabs } from "antd";
import { AddOutlined } from "@mui/icons-material";
import BillingTable from "./billingTable";
import AdvanceDetals from "./Modals/additional-details";
import DraftBill from "./draftBills";
import AddItemProduct from "./Modals/addItemToProduct";
import { useBilling } from "../KOTbillingProvider";
import { useDispatch } from "react-redux";
import Invoice from "../../Invoice/Invoice";
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      margin: "0",
    },
    "& h4": {
      margin: "0",
    },
  },
  tabs: {
    "& .ant-tabs-nav": {
      background: "#FDFBE8",
      "& .ant-tabs-tab-active": {
        background: "#fff",
      },
    },
    "& .ant-tabs-tab": {
      padding: "16px 36px",
      margin: "0",
    },
  },
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
  },
  contentListStyle: {
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "body::-webkit-scrollbar-thumb": {
      borderRadius: "20px",
    },
  },
}));

const BillinsTabs = ({ setTabKey, tabKey }) => {
  const [addItemModal, setAddItemModal] = React.useState(false);
  const [settingModal, setSettingModal] = React.useState(false);
  const dispatch = useDispatch();
  const handleRemoveAll = () => {
    dispatch({
      type: "SET_BILL_DRAFT",
      payload: [],
    });
  };
  const { clearAll } = useBilling();
  const classes = useStyles();
  const handleTabs = (key) => {
    setTabKey(key);
  };
  const handleClick = () => {
    setAddItemModal(true);
  };
  const handleAddvanceSetting = () => {
    setSettingModal(true);
  };
  const handleClearAll = () => {
    clearAll?.();
  };
  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <Tabs
        style={{
          margin: "1rem",
        }}
        activeKey={tabKey}
        onChange={handleTabs}
        className={classes.tabs}
      >
        <TabPane tab="Current" key={"1"}>
          <BillingTable />
        </TabPane>
        <TabPane tab="Drafts" key="2">
          <DraftBill setTabKey={setTabKey} />
        </TabPane>
      </Tabs>
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "2rem",
        }}
      >
        {tabKey === "1" && (
          <>
            <Button type="link" onClick={handleAddvanceSetting}>
              Advance Settings
            </Button>
            <Button type="link" onClick={handleClick}>
              <AddOutlined />
              Add Items
            </Button>
            <Button type="link" onClick={handleClearAll}>
              Clear All
            </Button>
          </>
        )}
        {tabKey === "2" && (
          <Button type="link" onClick={handleRemoveAll}>
            Remove All
          </Button>
        )}
      </div>
      <AddItemProduct open={addItemModal} setOpen={setAddItemModal} />
      <AdvanceDetals
        setSettingModal={setSettingModal}
        settingModal={settingModal}
      />
    </div>
  );
};

export default BillinsTabs;
